import styled from "styled-components"
import Photo0101 from "../../img/01_01.jpg"
import Photo0102 from "../../img/01_02.jpg"
import Photo0103 from "../../img/01_03.jpg"
import Photo0104 from "../../img/01_04.jpg"
import Photo0105 from "../../img/01_05.jpg"
import Photo0106 from "../../img/01_06.jpg"

const ContentBase01 = styled.div`
  background: #111;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
`
function SubMenuContent01() {
  return (
    <ContentBase01>
      <div className="typobase02">
        PC와 Mobile, TV, 인쇄매체까지 매체마다 다양한 포맷방식을 가지고 그에따른
        디자인 편집적인 요소를 결정합니다. 디자인에서 편집은 매체 특성을
        파악하면 디자인에서 편집적인 요소는 순조롭게 진행 할수 있습니다. 반면에
        그래픽은 매체 특성에 일괄적인 표현 방법이 아닌 서비스 특성에 따라 다양한
        표현방법을 요구합니다. 디자이너에게 그래픽 능력은 어느 영역에서나
        우선적으로 지녀야 할 필수 요소이며, 그에따른 학습은 경력이 쌓여도 꾸준히
        이뤄져야 하는 부분입니다.
      </div>
      <div className="typotitle">Alfa Lomeo 4C</div>
      <img src={Photo0101} className="photobase" alt="Photo0401"></img>
      <div className="typotitle">Gotham Drama Poster</div>
      <img src={Photo0102} className="photobase" alt="Photo0401"></img>
      <div className="typotitle">Kingsman Movie Poster</div>
      <img src={Photo0103} className="photobase" alt="Photo0401"></img>
      <div className="typotitle">Cosmetic Exhibition Event</div>
      <img src={Photo0104} className="photobase" alt="Photo0401"></img>
      <div className="typotitle">Smoker Pororo Visual Cut</div>
      <img src={Photo0105} className="photobase" alt="Photo0401"></img>
      <div className="typotitle">SONY Smart Wach SW2</div>
      <img src={Photo0106} className="photobase" alt="Photo0401"></img>
    </ContentBase01>
  )
}

export default SubMenuContent01
